"use strict";

var _defineProperty = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PloniUltralight = exports.PloniUltrabold = exports.PloniRegular = exports.PloniMedium = exports.PloniLight = exports.PloniDemibold = exports.PloniBold = exports.PloniBlack = void 0;
var _ploniBlackAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-black-aaa.woff2"));
var _ploniBlackAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-black-aaa.woff"));
var _ploniBlackAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-black-aaa.eot"));
var _ploniUltraboldAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-ultrabold-aaa.woff2"));
var _ploniUltraboldAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-ultrabold-aaa.woff"));
var _ploniUltraboldAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-ultrabold-aaa.eot"));
var _ploniBoldAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-bold-aaa.woff2"));
var _ploniBoldAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-bold-aaa.woff"));
var _ploniBoldAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-bold-aaa.eot"));
var _ploniDemiboldAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-demibold-aaa.woff2"));
var _ploniDemiboldAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-demibold-aaa.woff"));
var _ploniDemiboldAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-demibold-aaa.eot"));
var _ploniMediumAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-medium-aaa.woff2"));
var _ploniMediumAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-medium-aaa.woff"));
var _ploniMediumAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-medium-aaa.eot"));
var _ploniRegularAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-regular-aaa.woff2"));
var _ploniRegularAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-regular-aaa.woff"));
var _ploniRegularAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-regular-aaa.eot"));
var _ploniLightAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-light-aaa.woff2"));
var _ploniLightAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-light-aaa.woff"));
var _ploniLightAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-light-aaa.eot"));
var _ploniUltralightAaa = _interopRequireDefault(require("../assets/fonts/ploni/ploni-ultralight-aaa.woff2"));
var _ploniUltralightAaa2 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-ultralight-aaa.woff"));
var _ploniUltralightAaa3 = _interopRequireDefault(require("../assets/fonts/ploni/ploni-ultralight-aaa.eot"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint no-dupe-keys: 0 */

var PloniUltralight = exports.PloniUltralight = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 200,
  src: "url(".concat(_ploniUltralightAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniUltralightAaa.default, ") format('woff2'),\n    url(").concat(_ploniUltralightAaa2.default, ") format('woff');\n  "));
var PloniLight = exports.PloniLight = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 300,
  src: "url(".concat(_ploniLightAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniLightAaa.default, ") format('woff2'),\n    url(").concat(_ploniLightAaa2.default, ") format('woff');\n  "));
var PloniRegular = exports.PloniRegular = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 400,
  src: "url(".concat(_ploniRegularAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniRegularAaa.default, ") format('woff2'),\n    url(").concat(_ploniRegularAaa2.default, ") format('woff');\n  "));
var PloniMedium = exports.PloniMedium = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 500,
  src: "url(".concat(_ploniMediumAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniMediumAaa.default, ") format('woff2'),\n    url(").concat(_ploniMediumAaa2.default, ") format('woff');\n  "));
var PloniDemibold = exports.PloniDemibold = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 600,
  src: "url(".concat(_ploniDemiboldAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniDemiboldAaa.default, ") format('woff2'),\n    url(").concat(_ploniDemiboldAaa2.default, ") format('woff');\n  "));
var PloniBold = exports.PloniBold = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 700,
  src: "url(".concat(_ploniBoldAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniBoldAaa.default, ") format('woff2'),\n    url(").concat(_ploniBoldAaa2.default, ") format('woff');\n  "));
var PloniUltrabold = exports.PloniUltrabold = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 800,
  src: "url(".concat(_ploniUltraboldAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniUltraboldAaa.default, ") format('woff2'),\n    url(").concat(_ploniUltraboldAaa2.default, ") format('woff');\n  "));
var PloniBlack = exports.PloniBlack = _defineProperty({
  fontDisplay: 'swap',
  fontFamily: 'Ploni',
  fontStyle: 'normal',
  fontWeight: 900,
  src: "url(".concat(_ploniBlackAaa3.default, ");")
}, "src", "\n    url(".concat(_ploniBlackAaa.default, ") format('woff2'),\n    url(").concat(_ploniBlackAaa2.default, ") format('woff');\n  "));